// packages/sdk/src/credits/MockCreditsApi.ts
import {
  CreditsApi,
  CreditBalance,
  CreditPlansCatalog,
  CreditSubscription,
  CreditsBillingContext,
  CreditsPurchaseResult,
  OpenPaywallOptions,
  Unsubscribe,
  GenerationCostEstimate,
  GenerationCostEstimateRequest,
} from './CreditsApi'
import { mockLog } from '../MockDebug'

const TAG = 'Mock Credits'

export class MockCreditsApi implements CreditsApi {
  private autoPaywallOnExhaustion = true
  private autoRetryOnPurchase = true
  private balance: CreditBalance = {
    available: 500,
    total: 600,
    freeDaily: { dailyCredits: 100, availableCredits: 100, nextResetAt: '2030-01-01T00:00:00.000Z' },
  }

  async getBillingContext(): Promise<CreditsBillingContext> {
    mockLog(TAG, 'getBillingContext → player / enforcement off')
    return { billedTo: 'player', playerChargesEnabled: false }
  }

  async getBalance(): Promise<CreditBalance> {
    mockLog(TAG, `getBalance → ${this.balance.available}/${this.balance.total}`)
    return this.balance
  }

  async getSubscription(): Promise<CreditSubscription> {
    return {
      status: 'none',
      tier: null,
      monthlyCredits: null,
      creditsRemaining: null,
      renewsAt: null,
      willRenew: false,
    }
  }

  async getPlans(): Promise<CreditPlansCatalog> {
    return {
      plans: [
        { tier: 'creator', productId: 'mock_creator_monthly', monthlyCredits: 1000, rolloverDays: 0 },
        { tier: 'plus', productId: 'mock_plus_monthly', monthlyCredits: 5000, rolloverDays: 30 },
      ],
      plansUnavailable: false,
      topUpPacks: [{ productId: 'mock_topup_small', credits: 500 }],
      freeDailyCredits: 100,
    }
  }

  async estimateGenerationCost(_request: GenerationCostEstimateRequest): Promise<GenerationCostEstimate> {
    throw new Error('Credit estimates require a server-backed host')
  }

  async openPaywall(options?: OpenPaywallOptions): Promise<CreditsPurchaseResult> {
    mockLog(TAG, `openPaywall focus=${options?.focus ?? 'plans'} (mock: cancelled)`)
    return { outcome: 'cancelled', balance: this.balance }
  }

  setAutoPaywallOnExhaustion(enabled: boolean): void {
    this.autoPaywallOnExhaustion = enabled
  }

  getAutoPaywallOnExhaustion(): boolean {
    return this.autoPaywallOnExhaustion
  }

  setAutoRetryOnPurchase(enabled: boolean): void {
    this.autoRetryOnPurchase = enabled
  }

  getAutoRetryOnPurchase(): boolean {
    return this.autoRetryOnPurchase
  }

  onBalanceChanged(_listener: (balance: CreditBalance) => void): Unsubscribe {
    return () => {}
  }
}
